import { ErrorField } from "../../../../types/ErrorField";
import TextEdit from "../../../molecules/TextEdit";
import SelectTextField from "../../../molecules/SelectTextField";
import { getErrorMessage } from "../../../../utils/formErrorUtils";

import MaskEdit from "../../../organisms/MaskEdit";


interface Props {
    form: any;
    errorFields: ErrorField[];
    changeForm: (field: string, value: string) => void;

    editForm?: boolean;
}


const IndividualFormTab1: React.FC<Props> = ({ form, errorFields, changeForm, editForm = false }) => {

    return (
        <div className="p-4 m-4">
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-2">
                    <MaskEdit
                        id="socialId"
                        label="CPF"
                        mask="___.___.___-__"
                        replacement={{ '_': /\d/ }}
                        value={form.socialId}
                        disabled={editForm}
                        onChange={(e) => changeForm("socialId", e.target.value)}
                        errorMessage={getErrorMessage(errorFields, "social_id")}
                    />
                </div>
                <div className="col-span-5">
                    <TextEdit
                        id="name"
                        label="Nome"
                        value={form.name}
                        onChange={(e) => changeForm("name", e.target.value.toUpperCase())}
                        errorMessage={getErrorMessage(errorFields, "name")}
                    />
                </div>
                <div className="col-span-5">
                    <TextEdit
                        id="email"
                        label="Email"
                        value={form.email}
                        onChange={(e) => changeForm("email", e.target.value.toUpperCase())}
                        errorMessage={getErrorMessage(errorFields, "email")}
                    />
                </div>
            </div>

            <div className="grid grid-cols-12 gap-4 mt-6">
                <div className="col-span-3">
                    <SelectTextField
                        id="isNationalNumber"
                        name='isNationalNumber'
                        label=""
                        value={form.isNationalNumber}
                        items={[{ "value": "1", "label": "Brasil" }, { "value": "2", "label": "Estrangeiro" }]}
                        onChange={(e) => changeForm("isNationalNumber", e.target.value)}
                        errorMessage={getErrorMessage(errorFields, "isNationalNumber")}
                    />
                </div>
                <div className="col-span-2">
                    <TextEdit
                        id="mobilePhone"
                        label="Celular"
                        value={form.isNationalNumber === "1" || form.isNationalNumber === 1
                            ? (() => {
                                const d = (form.mobilePhone || '').replace(/\D/g, '');
                                if (d.length === 11) return `(${d.slice(0,2)})${d.slice(2,7)}-${d.slice(7)}`;
                                if (d.length === 10) return `(${d.slice(0,2)})${d.slice(2,6)}-${d.slice(6)}`;
                                return d;
                            })()
                            : (form.mobilePhone || '')}
                        onChange={(e) => changeForm("mobilePhone", e.target.value.replace(/\D/g, '').slice(0, form.isNationalNumber === "1" || form.isNationalNumber === 1 ? 11 : 20))}
                        errorMessage={getErrorMessage(errorFields, "mobilePhone")}
                    />
                </div>
                <div className="col-span-2">
                    <MaskEdit
                        id="phone"
                        label="Fixo"
                        mask="(__)____-____"
                        replacement={{ '_': /\d/ }}
                        value={form.phone}
                        onChange={(e) => changeForm("phone", e.target.value)}
                        errorMessage={getErrorMessage(errorFields, "phone")}
                    />
                </div>
            </div>
        </div>
    );
};

export default IndividualFormTab1;
